import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Document } from '../Icons';
import { Checkbox } from '@haldor/ui';
import './Style.scss';

var FileList = /*#__PURE__*/function (_Component) {
  _inherits(FileList, _Component);

  var _super = _createSuper(FileList);

  function FileList() {
    var _this;

    _classCallCheck(this, FileList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onFolderClick", function (folder) {
      if (_this.props.onFolderClick) {
        _this.props.onFolderClick(folder);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFileClick", function (file) {
      if (_this.props.onFileClick) {
        _this.props.onFileClick(file);
      }
    });

    return _this;
  }

  _createClass(FileList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          files = _this$props.files,
          selectedFiles = _this$props.selectedFiles;
      return /*#__PURE__*/React.createElement("div", {
        className: "file-list"
      }, this.props.files.map(function (file) {
        if (file.folder) {
          return /*#__PURE__*/React.createElement("div", {
            className: "list-directory",
            key: file.id,
            onClick: function onClick(e) {
              _this2.onFolderClick(file);
            }
          }, /*#__PURE__*/React.createElement("strong", null, file.name), /*#__PURE__*/React.createElement("div", {
            className: "clearfix"
          }));
        } else {
          var isSelected = _this2.props.selectedFiles.find(function (selF) {
            return selF.id == file.id;
          });

          var selected = isSelected != null;
          return /*#__PURE__*/React.createElement("div", {
            className: selected ? "list-file active" : "list-file",
            key: file.id,
            onClick: function onClick(e) {
              e.preventDefault();

              _this2.onFileClick(file);
            }
          }, /*#__PURE__*/React.createElement("span", {
            className: "icon-container"
          }, /*#__PURE__*/React.createElement(Document, null)), /*#__PURE__*/React.createElement("span", {
            className: "checkbox-container"
          }, /*#__PURE__*/React.createElement(Checkbox, {
            id: 'checkbox-' + file.id,
            value: selected
          })), /*#__PURE__*/React.createElement("div", {
            className: "info"
          }, file.name), /*#__PURE__*/React.createElement("div", {
            className: "clearfix"
          }));
        }
      }));
    }
  }]);

  return FileList;
}(Component);

export default FileList;